import type { NewConnection } from '#/domain/connection/NewConnection'
import type { ConnectionRepository } from '#/domain/connection/ConnectionRepository'

export class CreateConnectionUseCase {
  constructor(private readonly repository: ConnectionRepository) {}

  async execute(connection: NewConnection): Promise<void> {
    return this.repository.create(connection)
  }
}
